export enum UserLevel {
  A1 = 'A1',
  A2 = 'A2',
  A3 = 'A3',
  A4 = 'A4',
  B1 = 'B1',
  B2 = 'B2',
  B3 = 'B3',
  B4 = 'B4',
  C1 = 'C1',
  C2 = 'C2',
  C3 = 'C3',
  C4 = 'C4',
  C5 = 'C5',
  IST3 = 'IST3',
  IST4 = 'IST4',
  IST5 = 'IST5',
  ISPTI3 = 'ISPTI3',
  IVC3 = 'IVC3',
  IVC4 = 'IVC4',
  IVC5 = 'IVC5',
  I1 = 'I1',
  I2 = 'I2',
  I3 = 'I3',
  I4 = 'I4',
  P1 = 'P1',
  P2 = 'P2',
  P3 = 'P3',
  P4 = 'P4',
}
